import { Text } from '@kueski-dev/kueski-design-system';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
  cursor: pointer;
  display: inline-block;
  max-width: 4.875rem;
  padding-top: 0;
  text-align: center;
`;

export const TextBreak = styled(Text)`
  white-space: pre-line;
`;
